import { render } from "./Announcement.vue?vue&type=template&id=5944f7d5"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Announcement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5944f7d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5944f7d5', __exports__)) {
    api.reload('5944f7d5', __exports__)
  }
  
  module.hot.accept("./Announcement.vue?vue&type=template&id=5944f7d5", () => {
    api.rerender('5944f7d5', render)
  })

}


export default __exports__